import { GetServices } from "./GetServices";

const fetchServices = async () => {   
    try {
      const data = await GetServices();
        return data;              
    } catch (error) {
      console.error("Error fetching services data:", error);
    }
  }

export const Services = fetchServices();